export function getUtmParams(searchParams: URLSearchParams) {
  let lookup: Record<string, string> | null = null;

  for (const [key, value] of searchParams) {
    if (!key.startsWith("utm_")) continue;

    lookup = {
      ...(lookup ?? {}),
      [key]: value,
    };
  }

  return lookup;
}
